<template>
  <div>
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-lg="3"
        vs-sm="12"
      >
        <vs-card class="cstm_vx_card">
          <div slot="header">
            <h4>Folders</h4>
          </div>

          <div class="files_items_collapse">
            <div
              class="cstm-collapse-item"
              :key="index.id"
              v-for="(item, index) in folders"
            >
              <div
                @click="activate(index)"
                :class="{ active: active_el == index }"
              >
                <div
                  class="header flex justify-between items-center"
                  @click="openFolder(item)"
                >
                  {{ item.repository_name }}
                  <span class="material-icons">expand_more</span>
                </div>
                <!-- <vs-collapse accordion>
              <vs-collapse-item class="cstm-collapse-item" :key="index.id" v-for="(item, index) in folders" > -->

                <div class="collapse_content">
                  <div
                    class="
                      flex flex-wrap
                      justify-between
                      my-2
                      folders_files_content
                    "
                  >
                    <createsubfolder
                      :repo_id="item.repository_id"
                      :repo_path="item.repository_path"
                      @addedSubFolder="addedSubFolder($event)"
                    />

                    <fileupload
                      :repo_id="item.repository_id"
                      :repo_path="item.repository_path"
                      :filesInfo="filesInfo"
                      @addedFile="addedFile($event)"
                    />
                  </div>

                  <!-- <div slot="header" @click="openFolder(item)" >
                      {{item.repository_name}}&nbsp;
                    </div> -->
                  <vs-row
                    :key="index2.id"
                    v-for="(item2, index2) in item.sub_repository"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="flex-start"
                    class="main_repo my-2"
                  >
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="center"
                    >
                      <vs-icon
                        v-if="item2.sub_repository.length === 0"
                        icon-pack="feather"
                        color="iconColor"
                        >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                      >
                      <vs-icon
                        class="styledButton"
                        v-if="item2.sub_repository.length != 0"
                        @click="toggleFolder(item2)"
                        icon-pack="feather"
                        icon="icon-chevron-right"
                        color="iconColor"
                      ></vs-icon>
                      <vs-icon
                        icon-pack="feather"
                        icon="icon-folder"
                        color="iconColor"
                      ></vs-icon>
                      <p class="cstm-folder-name" @click="openFolder(item2)">
                        &nbsp;{{ item2.repository_name }}
                      </p>
                      <vs-tooltip v-if="checkDeletePermission()" text="Delete" position="bottom">
                        &nbsp;<vs-icon
                          type="flat"
                          icon-pack="feather"
                          @click="folderDelete(item2.repository_id)"
                          color="danger"
                          icon="icon-trash-2"
                        ></vs-icon>
                        <span></span>
                      </vs-tooltip>
                    </vs-col>

                    <span
                      :style="{ display: 'none' }"
                      :ref="item2.repository_name"
                      v-if="item2.sub_repository.length != 0"
                    >
                      <vs-row
                        :key="index3.id"
                        v-for="(item3, index3) in item2.sub_repository"
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="flex-start"
                      >
                        <vs-col
                          vs-type="flex"
                          vs-justify="flex-start"
                          vs-align="center"
                        >
                          &nbsp;<vs-icon
                            v-if="item3.sub_repository.length === 0"
                            icon-pack="feather"
                            color="iconColor"
                            >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                          >
                          <vs-icon
                            class="styledButton"
                            v-if="item3.sub_repository.length != 0"
                            @click="toggleFolder(item3)"
                            icon-pack="feather"
                            icon="icon-chevron-right"
                            color="iconColor"
                          ></vs-icon>
                          <vs-icon
                            icon-pack="feather"
                            icon="icon-folder"
                            color="iconColor"
                          ></vs-icon>
                          <p @click="openFolder(item3)">
                            &nbsp;{{ item3.repository_name }}
                          </p>
                          <vs-tooltip v-if="checkDeletePermission()" text="Delete" position="bottom">
                            &nbsp;<vs-icon
                              type="flat"
                              icon-pack="feather"
                              @click="folderDelete(item3.repository_id)"
                              color="danger"
                              icon="icon-trash-2"
                            ></vs-icon>
                            <span></span>
                          </vs-tooltip>
                        </vs-col>
                        <span
                          :style="{ display: 'none' }"
                          :ref="item3.repository_name"
                          v-if="item3.sub_repository.length != 0"
                        >
                          <vs-row
                            :key="index4.id"
                            v-for="(item4, index4) in item3.sub_repository"
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="flex-start"
                          >
                            <vs-col
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="center"
                            >
                              &nbsp;&nbsp;<vs-icon
                                v-if="item4.sub_repository.length === 0"
                                icon-pack="feather"
                                color="iconColor"
                                >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                              >
                              <vs-icon
                                class="styledButton"
                                v-if="item4.sub_repository.length != 0"
                                @click="toggleFolder(item4)"
                                icon-pack="feather"
                                icon="icon-chevron-right"
                                color="iconColor"
                              ></vs-icon>
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-folder"
                                color="iconColor"
                              ></vs-icon>
                              <p @click="openFolder(item4)">
                                &nbsp;{{ item4.repository_name }}
                              </p>
                              <vs-tooltip v-if="checkDeletePermission()" text="Delete" position="bottom">
                                &nbsp;<vs-icon
                                  type="flat"
                                  icon-pack="feather"
                                  @click="folderDelete(item4.repository_id)"
                                  color="danger"
                                  icon="icon-trash-2"
                                ></vs-icon>
                                <span></span>
                              </vs-tooltip>
                            </vs-col>
                            <span
                              :style="{ display: 'none' }"
                              :ref="item4.repository_name"
                              v-if="item4.sub_repository.length != 0"
                            >
                              <vs-row
                                :key="index5.id"
                                v-for="(item5, index5) in item4.sub_repository"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <vs-col
                                  vs-type="flex"
                                  vs-justify="flex-start"
                                  vs-align="center"
                                >
                                  &nbsp;&nbsp;&nbsp;<vs-icon
                                    v-if="item5.sub_repository.length === 0"
                                    icon-pack="feather"
                                    color="iconColor"
                                    >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                  >
                                  <vs-icon
                                    class="styledButton"
                                    v-if="item5.sub_repository.length != 0"
                                    @click="toggleFolder(item5)"
                                    icon-pack="feather"
                                    icon="icon-chevron-right"
                                    color="iconColor"
                                  ></vs-icon>
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-folder"
                                    color="iconColor"
                                  ></vs-icon>
                                  <p @click="openFolder(item5)">
                                    &nbsp;{{ item5.repository_name }}
                                  </p>
                                  <vs-tooltip v-if="checkDeletePermission()" text="Delete" position="bottom">
                                    &nbsp;<vs-icon
                                      type="flat"
                                      icon-pack="feather"
                                      @click="folderDelete(item5.repository_id)"
                                      color="danger"
                                      icon="icon-trash-2"
                                    ></vs-icon>
                                    <span></span>
                                  </vs-tooltip>
                                </vs-col>
                                <span
                                  :style="{ display: 'none' }"
                                  :ref="item5.repository_name"
                                  v-if="item5.sub_repository.length != 0"
                                >
                                  <vs-row
                                    :key="index6.id"
                                    v-for="(
                                      item6, index6
                                    ) in item5.sub_repository"
                                    vs-type="flex"
                                    vs-justify="flex-start"
                                    vs-align="flex-start"
                                  >
                                    <vs-col
                                      vs-type="flex"
                                      vs-justify="flex-start"
                                      vs-align="center"
                                    >
                                      &nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                        v-if="item6.sub_repository.length === 0"
                                        icon-pack="feather"
                                        color="iconColor"
                                        >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                      >
                                      <vs-icon
                                        class="styledButton"
                                        v-if="item6.sub_repository.length != 0"
                                        @click="toggleFolder(item6)"
                                        icon-pack="feather"
                                        icon="icon-chevron-right"
                                        color="iconColor"
                                      ></vs-icon>
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-folder"
                                        color="iconColor"
                                      ></vs-icon>
                                      <p @click="openFolder(item6)">
                                        &nbsp;{{ item6.repository_name }}
                                      </p>
                                      <vs-tooltip
                                        v-if="checkDeletePermission()"
                                        text="Delete"
                                        position="bottom"
                                      >
                                        &nbsp;<vs-icon
                                          type="flat"
                                          icon-pack="feather"
                                          @click="
                                            folderDelete(item6.repository_id)
                                          "
                                          color="danger"
                                          icon="icon-trash-2"
                                        ></vs-icon>
                                        <span></span>
                                      </vs-tooltip>
                                    </vs-col>
                                    <span
                                      :style="{ display: 'none' }"
                                      :ref="item6.repository_name"
                                      v-if="item6.sub_repository.length != 0"
                                    >
                                      <vs-row
                                        :key="index7.id"
                                        v-for="(
                                          item7, index7
                                        ) in item6.sub_repository"
                                        vs-type="flex"
                                        vs-justify="flex-start"
                                        vs-align="flex-start"
                                      >
                                        <vs-col
                                          vs-type="flex"
                                          vs-justify="flex-start"
                                          vs-align="center"
                                        >
                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                            v-if="
                                              item7.sub_repository.length === 0
                                            "
                                            icon-pack="feather"
                                            color="iconColor"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                          >
                                          <vs-icon
                                            class="styledButton"
                                            v-if="
                                              item7.sub_repository.length != 0
                                            "
                                            @click="toggleFolder(item7)"
                                            icon-pack="feather"
                                            icon="icon-chevron-right"
                                            color="iconColor"
                                          ></vs-icon>
                                          <vs-icon
                                            icon-pack="feather"
                                            icon="icon-folder"
                                            color="iconColor"
                                          ></vs-icon>
                                          <p @click="openFolder(item7)">
                                            &nbsp;{{ item7.repository_name }}
                                          </p>
                                          <vs-tooltip
                                            v-if="checkDeletePermission()"
                                            text="Delete"
                                            position="bottom"
                                          >
                                            &nbsp;<vs-icon
                                              type="flat"
                                              icon-pack="feather"
                                              @click="
                                                folderDelete(
                                                  item7.repository_id
                                                )
                                              "
                                              color="danger"
                                              icon="icon-trash-2"
                                            ></vs-icon>
                                            <span></span>
                                          </vs-tooltip>
                                        </vs-col>
                                        <span
                                          :style="{ display: 'none' }"
                                          :ref="item7.repository_name"
                                          v-if="
                                            item7.sub_repository.length != 0
                                          "
                                        >
                                          <vs-row
                                            :key="index8.id"
                                            v-for="(
                                              item8, index8
                                            ) in item7.sub_repository"
                                            vs-type="flex"
                                            vs-justify="flex-start"
                                            vs-align="flex-start"
                                          >
                                            <vs-col
                                              vs-type="flex"
                                              vs-justify="flex-start"
                                              vs-align="center"
                                            >
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                v-if="
                                                  item8.sub_repository
                                                    .length === 0
                                                "
                                                >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                              >
                                              <vs-icon
                                                class="styledButton"
                                                v-if="
                                                  item8.sub_repository.length !=
                                                  0
                                                "
                                                @click="toggleFolder(item8)"
                                                icon-pack="feather"
                                                icon="icon-chevron-right"
                                                color="iconColor"
                                              ></vs-icon>
                                              <vs-icon
                                                icon-pack="feather"
                                                icon="icon-folder"
                                                color="iconColor"
                                              ></vs-icon>
                                              <p @click="openFolder(item8)">
                                                &nbsp;{{
                                                  item8.repository_name
                                                }}
                                              </p>
                                              <vs-tooltip
                                                v-if="checkDeletePermission()"
                                                text="Delete"
                                                position="bottom"
                                              >
                                                &nbsp;<vs-icon
                                                  type="flat"
                                                  icon-pack="feather"
                                                  @click="
                                                    folderDelete(
                                                      item8.repository_id
                                                    )
                                                  "
                                                  color="danger"
                                                  icon="icon-trash-2"
                                                ></vs-icon>
                                                <span></span>
                                              </vs-tooltip>
                                            </vs-col>
                                            <span
                                              :style="{ display: 'none' }"
                                              :ref="item8.repository_name"
                                              v-if="
                                                item8.sub_repository.length != 0
                                              "
                                            >
                                              <vs-row
                                                :key="index9.id"
                                                v-for="(
                                                  item9, index9
                                                ) in item8.sub_repository"
                                                vs-type="flex"
                                                vs-justify="flex-start"
                                                vs-align="flex-start"
                                              >
                                                <vs-col
                                                  vs-type="flex"
                                                  vs-justify="flex-start"
                                                  vs-align="center"
                                                >
                                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                    v-if="
                                                      item9.sub_repository
                                                        .length === 0
                                                    "
                                                    >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                  >
                                                  <vs-icon
                                                    class="styledButton"
                                                    v-if="
                                                      item9.sub_repository
                                                        .length != 0
                                                    "
                                                    @click="toggleFolder(item9)"
                                                    icon-pack="feather"
                                                    icon="icon-chevron-right"
                                                    color="iconColor"
                                                  ></vs-icon>
                                                  <vs-icon
                                                    icon-pack="feather"
                                                    icon="icon-folder"
                                                    color="iconColor"
                                                  ></vs-icon>
                                                  <p @click="openFolder(item9)">
                                                    &nbsp;{{
                                                      item9.repository_name
                                                    }}
                                                  </p>
                                                  <vs-tooltip
                                                    v-if="checkDeletePermission()"
                                                    text="Delete"
                                                    position="bottom"
                                                  >
                                                    &nbsp;<vs-icon
                                                      type="flat"
                                                      icon-pack="feather"
                                                      @click="
                                                        folderDelete(
                                                          item9.repository_id
                                                        )
                                                      "
                                                      color="danger"
                                                      icon="icon-trash-2"
                                                    ></vs-icon>
                                                    <span></span>
                                                  </vs-tooltip>
                                                </vs-col>
                                                <span
                                                  :style="{ display: 'none' }"
                                                  :ref="item9.repository_name"
                                                  v-if="
                                                    item9.sub_repository
                                                      .length != 0
                                                  "
                                                >
                                                  <vs-row
                                                    :key="index10.id"
                                                    v-for="(
                                                      item10, index10
                                                    ) in item9.sub_repository"
                                                    vs-type="flex"
                                                    vs-justify="flex-start"
                                                    vs-align="flex-start"
                                                  >
                                                    <vs-col
                                                      vs-type="flex"
                                                      vs-justify="flex-start"
                                                      vs-align="center"
                                                    >
                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                        v-if="
                                                          item10.sub_repository
                                                            .length === 0
                                                        "
                                                        icon-pack="feather"
                                                        color="iconColor"
                                                        >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                      >
                                                      <vs-icon
                                                        class="styledButton"
                                                        v-if="
                                                          item10.sub_repository
                                                            .length != 0
                                                        "
                                                        @click="
                                                          toggleFolder(item10)
                                                        "
                                                        icon-pack="feather"
                                                        icon="icon-chevron-right"
                                                        color="iconColor"
                                                      ></vs-icon>
                                                      <vs-icon
                                                        icon-pack="feather"
                                                        icon="icon-folder"
                                                        color="iconColor"
                                                      ></vs-icon>
                                                      <p
                                                        @click="
                                                          openFolder(item10)
                                                        "
                                                      >
                                                        &nbsp;{{
                                                          item10.repository_name
                                                        }}
                                                      </p>
                                                      <vs-tooltip
                                                        text="Delete"
                                                        position="bottom"
                                                        v-if="checkDeletePermission()"
                                                      >
                                                        &nbsp;<vs-icon
                                                          type="flat"
                                                          icon-pack="feather"
                                                          @click="
                                                            folderDelete(
                                                              item10.repository_id
                                                            )
                                                          "
                                                          color="danger"
                                                          icon="icon-trash-2"
                                                        ></vs-icon>
                                                        <span></span>
                                                      </vs-tooltip>
                                                    </vs-col>
                                                    <span
                                                      :style="{
                                                        display: 'none',
                                                      }"
                                                      :ref="
                                                        item10.repository_name
                                                      "
                                                      v-if="
                                                        item10.sub_repository
                                                          .length != 0
                                                      "
                                                    >
                                                      <vs-row
                                                        :key="index11.id"
                                                        v-for="(
                                                          item11, index11
                                                        ) in item10.sub_repository"
                                                        vs-type="flex"
                                                        vs-justify="flex-start"
                                                        vs-align="flex-start"
                                                      >
                                                        <vs-col
                                                          vs-type="flex"
                                                          vs-justify="flex-start"
                                                          vs-align="center"
                                                        >
                                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                            v-if="
                                                              item11
                                                                .sub_repository
                                                                .length === 0
                                                            "
                                                            icon-pack="feather"
                                                            color="iconColor"
                                                            >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                          >
                                                          <vs-icon
                                                            class="styledButton"
                                                            v-if="
                                                              item11
                                                                .sub_repository
                                                                .length != 0
                                                            "
                                                            @click="
                                                              toggleFolder(
                                                                item11
                                                              )
                                                            "
                                                            icon-pack="feather"
                                                            icon="icon-chevron-right"
                                                            color="iconColor"
                                                          ></vs-icon>
                                                          <vs-icon
                                                            icon-pack="feather"
                                                            icon="icon-folder"
                                                            color="iconColor"
                                                          ></vs-icon>
                                                          <p
                                                            @click="
                                                              openFolder(item11)
                                                            "
                                                          >
                                                            &nbsp;{{
                                                              item11.repository_name
                                                            }}
                                                          </p>
                                                          <vs-tooltip
                                                            text="Delete"
                                                            position="bottom"
                                                            v-if="checkDeletePermission()"
                                                          >
                                                            &nbsp;<vs-icon
                                                              type="flat"
                                                              icon-pack="feather"
                                                              @click="
                                                                folderDelete(
                                                                  item11.repository_id
                                                                )
                                                              "
                                                              color="danger"
                                                              icon="icon-trash-2"
                                                            ></vs-icon>
                                                            <span></span>
                                                          </vs-tooltip>
                                                        </vs-col>
                                                        <span
                                                          :style="{
                                                            display: 'none',
                                                          }"
                                                          :ref="
                                                            item11.repository_name
                                                          "
                                                          v-if="
                                                            item11
                                                              .sub_repository
                                                              .length != 0
                                                          "
                                                        >
                                                          <vs-row
                                                            :key="index12.id"
                                                            v-for="(
                                                              item12, index12
                                                            ) in item11.sub_repository"
                                                            vs-type="flex"
                                                            vs-justify="flex-start"
                                                            vs-align="flex-start"
                                                          >
                                                            <vs-col
                                                              vs-type="flex"
                                                              vs-justify="flex-start"
                                                              vs-align="center"
                                                            >
                                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                v-if="
                                                                  item12
                                                                    .sub_repository
                                                                    .length ===
                                                                  0
                                                                "
                                                                icon-pack="feather"
                                                                color="iconColor"
                                                                >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                              >
                                                              <vs-icon
                                                                class="
                                                                  styledButton
                                                                "
                                                                v-if="
                                                                  item12
                                                                    .sub_repository
                                                                    .length != 0
                                                                "
                                                                @click="
                                                                  toggleFolder(
                                                                    item12
                                                                  )
                                                                "
                                                                icon-pack="feather"
                                                                icon="icon-chevron-right"
                                                                color="iconColor"
                                                              ></vs-icon>
                                                              <vs-icon
                                                                icon-pack="feather"
                                                                icon="icon-folder"
                                                                color="iconColor"
                                                              ></vs-icon>
                                                              <p
                                                                @click="
                                                                  openFolder(
                                                                    item12
                                                                  )
                                                                "
                                                              >
                                                                &nbsp;{{
                                                                  item12.repository_name
                                                                }}
                                                              </p>
                                                              <vs-tooltip
                                                                text="Delete"
                                                                position="bottom"
                                                                v-if="checkDeletePermission()"
                                                              >
                                                                &nbsp;<vs-icon
                                                                  type="flat"
                                                                  icon-pack="feather"
                                                                  @click="
                                                                    folderDelete(
                                                                      item12.repository_id
                                                                    )
                                                                  "
                                                                  color="danger"
                                                                  icon="icon-trash-2"
                                                                ></vs-icon>
                                                                <span></span>
                                                              </vs-tooltip>
                                                            </vs-col>
                                                            <span
                                                              :style="{
                                                                display: 'none',
                                                              }"
                                                              :ref="
                                                                item12.repository_name
                                                              "
                                                              v-if="
                                                                item12
                                                                  .sub_repository
                                                                  .length != 0
                                                              "
                                                            >
                                                              <vs-row
                                                                :key="
                                                                  index13.id
                                                                "
                                                                v-for="(
                                                                  item13,
                                                                  index13
                                                                ) in item12.sub_repository"
                                                                vs-type="flex"
                                                                vs-justify="flex-start"
                                                                vs-align="flex-start"
                                                              >
                                                                <vs-col
                                                                  vs-type="flex"
                                                                  vs-justify="flex-start"
                                                                  vs-align="center"
                                                                >
                                                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                    v-if="
                                                                      item13
                                                                        .sub_repository
                                                                        .length ===
                                                                      0
                                                                    "
                                                                    icon-pack="feather"
                                                                    color="iconColor"
                                                                    >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                  >
                                                                  <vs-icon
                                                                    class="
                                                                      styledButton
                                                                    "
                                                                    v-if="
                                                                      item13
                                                                        .sub_repository
                                                                        .length !=
                                                                      0
                                                                    "
                                                                    @click="
                                                                      toggleFolder(
                                                                        item13
                                                                      )
                                                                    "
                                                                    icon-pack="feather"
                                                                    icon="icon-chevron-right"
                                                                    color="iconColor"
                                                                  ></vs-icon>
                                                                  <vs-icon
                                                                    icon-pack="feather"
                                                                    icon="icon-folder"
                                                                    color="iconColor"
                                                                  ></vs-icon>
                                                                  <p
                                                                    @click="
                                                                      openFolder(
                                                                        item13
                                                                      )
                                                                    "
                                                                  >
                                                                    &nbsp;{{
                                                                      item13.repository_name
                                                                    }}
                                                                  </p>
                                                                  <vs-tooltip
                                                                    text="Delete"
                                                                    position="bottom"
                                                                    v-if="checkDeletePermission()"
                                                                  >
                                                                    &nbsp;<vs-icon
                                                                      type="flat"
                                                                      icon-pack="feather"
                                                                      @click="
                                                                        folderDelete(
                                                                          item13.repository_id
                                                                        )
                                                                      "
                                                                      color="danger"
                                                                      icon="icon-trash-2"
                                                                    ></vs-icon>
                                                                    <span></span>
                                                                  </vs-tooltip>
                                                                </vs-col>
                                                                <span
                                                                  :style="{
                                                                    display:
                                                                      'none',
                                                                  }"
                                                                  :ref="
                                                                    item13.repository_name
                                                                  "
                                                                  v-if="
                                                                    item13
                                                                      .sub_repository
                                                                      .length !=
                                                                    0
                                                                  "
                                                                >
                                                                  <vs-row
                                                                    :key="
                                                                      index14.id
                                                                    "
                                                                    v-for="(
                                                                      item14,
                                                                      index14
                                                                    ) in item13.sub_repository"
                                                                    vs-type="flex"
                                                                    vs-justify="flex-start"
                                                                    vs-align="flex-start"
                                                                  >
                                                                    <vs-col
                                                                      vs-type="flex"
                                                                      vs-justify="flex-start"
                                                                      vs-align="center"
                                                                    >
                                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                        v-if="
                                                                          item14
                                                                            .sub_repository
                                                                            .length ===
                                                                          0
                                                                        "
                                                                        icon-pack="feather"
                                                                        color="iconColor"
                                                                        >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                      >
                                                                      <vs-icon
                                                                        class="
                                                                          styledButton
                                                                        "
                                                                        v-if="
                                                                          item14
                                                                            .sub_repository
                                                                            .length !=
                                                                          0
                                                                        "
                                                                        @click="
                                                                          toggleFolder(
                                                                            item14
                                                                          )
                                                                        "
                                                                        icon-pack="feather"
                                                                        icon="icon-chevron-right"
                                                                        color="iconColor"
                                                                      ></vs-icon>
                                                                      <vs-icon
                                                                        icon-pack="feather"
                                                                        icon="icon-folder"
                                                                        color="iconColor"
                                                                      ></vs-icon>
                                                                      <p
                                                                        @click="
                                                                          openFolder(
                                                                            item14
                                                                          )
                                                                        "
                                                                      >
                                                                        &nbsp;{{
                                                                          item14.repository_name
                                                                        }}
                                                                      </p>
                                                                      <vs-tooltip
                                                                        text="Delete"
                                                                        position="bottom"
                                                                        v-if="checkDeletePermission()"
                                                                      >
                                                                        &nbsp;<vs-icon
                                                                          type="flat"
                                                                          icon-pack="feather"
                                                                          @click="
                                                                            folderDelete(
                                                                              item14.repository_id
                                                                            )
                                                                          "
                                                                          color="danger"
                                                                          icon="icon-trash-2"
                                                                        ></vs-icon>
                                                                        <span></span>
                                                                      </vs-tooltip>
                                                                    </vs-col>
                                                                    <span
                                                                      :style="{
                                                                        display:
                                                                          'none',
                                                                      }"
                                                                      :ref="
                                                                        item14.repository_name
                                                                      "
                                                                      v-if="
                                                                        item14
                                                                          .sub_repository
                                                                          .length !=
                                                                        0
                                                                      "
                                                                    >
                                                                      <vs-row
                                                                        :key="
                                                                          index15.id
                                                                        "
                                                                        v-for="(
                                                                          item15,
                                                                          index15
                                                                        ) in item14.sub_repository"
                                                                        vs-type="flex"
                                                                        vs-justify="flex-start"
                                                                        vs-align="flex-start"
                                                                      >
                                                                        <vs-col
                                                                          vs-type="flex"
                                                                          vs-justify="flex-start"
                                                                          vs-align="center"
                                                                        >
                                                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                            v-if="
                                                                              item15
                                                                                .sub_repository
                                                                                .length ===
                                                                              0
                                                                            "
                                                                            icon-pack="feather"
                                                                            color="iconColor"
                                                                            >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                          >
                                                                          <vs-icon
                                                                            class="
                                                                              styledButton
                                                                            "
                                                                            v-if="
                                                                              item15
                                                                                .sub_repository
                                                                                .length !=
                                                                              0
                                                                            "
                                                                            @click="
                                                                              toggleFolder(
                                                                                item15
                                                                              )
                                                                            "
                                                                            icon-pack="feather"
                                                                            icon="icon-chevron-right"
                                                                            color="iconColor"
                                                                          ></vs-icon>
                                                                          <vs-icon
                                                                            icon-pack="feather"
                                                                            icon="icon-folder"
                                                                            color="iconColor"
                                                                          ></vs-icon>
                                                                          <p
                                                                            @click="
                                                                              openFolder(
                                                                                item15
                                                                              )
                                                                            "
                                                                          >
                                                                            &nbsp;{{
                                                                              item15.repository_name
                                                                            }}
                                                                          </p>
                                                                          <vs-tooltip
                                                                            text="Delete"
                                                                            position="bottom"
                                                                            v-if="checkDeletePermission()"
                                                                          >
                                                                            &nbsp;<vs-icon
                                                                              type="flat"
                                                                              icon-pack="feather"
                                                                              @click="
                                                                                folderDelete(
                                                                                  item15.repository_id
                                                                                )
                                                                              "
                                                                              color="danger"
                                                                              icon="icon-trash-2"
                                                                            ></vs-icon>
                                                                            <span></span>
                                                                          </vs-tooltip>
                                                                        </vs-col>
                                                                        <span
                                                                          :style="{
                                                                            display:
                                                                              'none',
                                                                          }"
                                                                          :ref="
                                                                            item15.repository_name
                                                                          "
                                                                          v-if="
                                                                            item15
                                                                              .sub_repository
                                                                              .length !=
                                                                            0
                                                                          "
                                                                        >
                                                                          <vs-row
                                                                            :key="
                                                                              index16.id
                                                                            "
                                                                            v-for="(
                                                                              item16,
                                                                              index16
                                                                            ) in item15.sub_repository"
                                                                            vs-type="flex"
                                                                            vs-justify="flex-start"
                                                                            vs-align="flex-start"
                                                                          >
                                                                            <vs-col
                                                                              vs-type="flex"
                                                                              vs-justify="flex-start"
                                                                              vs-align="center"
                                                                            >
                                                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                                v-if="
                                                                                  item16
                                                                                    .sub_repository
                                                                                    .length ===
                                                                                  0
                                                                                "
                                                                                icon-pack="feather"
                                                                                color="iconColor"
                                                                                >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                              >
                                                                              <vs-icon
                                                                                class="
                                                                                  styledButton
                                                                                "
                                                                                v-if="
                                                                                  item16
                                                                                    .sub_repository
                                                                                    .length !=
                                                                                  0
                                                                                "
                                                                                @click="
                                                                                  toggleFolder(
                                                                                    item16
                                                                                  )
                                                                                "
                                                                                icon-pack="feather"
                                                                                icon="icon-chevron-right"
                                                                                color="iconColor"
                                                                              ></vs-icon>
                                                                              <vs-icon
                                                                                icon-pack="feather"
                                                                                icon="icon-folder"
                                                                                color="iconColor"
                                                                              ></vs-icon>
                                                                              <p
                                                                                @click="
                                                                                  openFolder(
                                                                                    item16
                                                                                  )
                                                                                "
                                                                              >
                                                                                &nbsp;{{
                                                                                  item16.repository_name
                                                                                }}
                                                                              </p>
                                                                              <vs-tooltip
                                                                                text="Delete"
                                                                                position="bottom"
                                                                                v-if="checkDeletePermission()"
                                                                              >
                                                                                &nbsp;<vs-icon
                                                                                  type="flat"
                                                                                  icon-pack="feather"
                                                                                  @click="
                                                                                    folderDelete(
                                                                                      item16.repository_id
                                                                                    )
                                                                                  "
                                                                                  color="danger"
                                                                                  icon="icon-trash-2"
                                                                                ></vs-icon>
                                                                                <span></span>
                                                                              </vs-tooltip>
                                                                            </vs-col>
                                                                            <span
                                                                              :style="{
                                                                                display:
                                                                                  'none',
                                                                              }"
                                                                              :ref="
                                                                                item16.repository_name
                                                                              "
                                                                              v-if="
                                                                                item16
                                                                                  .sub_repository
                                                                                  .length !=
                                                                                0
                                                                              "
                                                                            >
                                                                              <vs-row
                                                                                :key="
                                                                                  index17.id
                                                                                "
                                                                                v-for="(
                                                                                  item17,
                                                                                  index17
                                                                                ) in item16.sub_repository"
                                                                                vs-type="flex"
                                                                                vs-justify="flex-start"
                                                                                vs-align="flex-start"
                                                                              >
                                                                                <vs-col
                                                                                  vs-type="flex"
                                                                                  vs-justify="flex-start"
                                                                                  vs-align="center"
                                                                                >
                                                                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                                    v-if="
                                                                                      item17
                                                                                        .sub_repository
                                                                                        .length ===
                                                                                      0
                                                                                    "
                                                                                    icon-pack="feather"
                                                                                    color="iconColor"
                                                                                    >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                                  >
                                                                                  <vs-icon
                                                                                    class="
                                                                                      styledButton
                                                                                    "
                                                                                    v-if="
                                                                                      item17
                                                                                        .sub_repository
                                                                                        .length !=
                                                                                      0
                                                                                    "
                                                                                    @click="
                                                                                      toggleFolder(
                                                                                        item17
                                                                                      )
                                                                                    "
                                                                                    icon-pack="feather"
                                                                                    icon="icon-chevron-right"
                                                                                    color="iconColor"
                                                                                  ></vs-icon>
                                                                                  <vs-icon
                                                                                    icon-pack="feather"
                                                                                    icon="icon-folder"
                                                                                    color="iconColor"
                                                                                  ></vs-icon>
                                                                                  <p
                                                                                    @click="
                                                                                      openFolder(
                                                                                        item17
                                                                                      )
                                                                                    "
                                                                                  >
                                                                                    &nbsp;{{
                                                                                      item17.repository_name
                                                                                    }}
                                                                                  </p>
                                                                                  <vs-tooltip
                                                                                    text="Delete"
                                                                                    position="bottom"
                                                                                    v-if="checkDeletePermission()"
                                                                                  >
                                                                                    &nbsp;<vs-icon
                                                                                      type="flat"
                                                                                      icon-pack="feather"
                                                                                      @click="
                                                                                        folderDelete(
                                                                                          item17.repository_id
                                                                                        )
                                                                                      "
                                                                                      color="danger"
                                                                                      icon="icon-trash-2"
                                                                                    ></vs-icon>
                                                                                    <span></span>
                                                                                  </vs-tooltip>
                                                                                </vs-col>
                                                                                <span
                                                                                  :style="{
                                                                                    display:
                                                                                      'none',
                                                                                  }"
                                                                                  :ref="
                                                                                    item17.repository_name
                                                                                  "
                                                                                  v-if="
                                                                                    item17
                                                                                      .sub_repository
                                                                                      .length !=
                                                                                    0
                                                                                  "
                                                                                >
                                                                                  <vs-row
                                                                                    :key="
                                                                                      index18.id
                                                                                    "
                                                                                    v-for="(
                                                                                      item18,
                                                                                      index18
                                                                                    ) in item17.sub_repository"
                                                                                    vs-type="flex"
                                                                                    vs-justify="flex-start"
                                                                                    vs-align="flex-start"
                                                                                  >
                                                                                    <vs-col
                                                                                      vs-type="flex"
                                                                                      vs-justify="flex-start"
                                                                                      vs-align="center"
                                                                                    >
                                                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                                        v-if="
                                                                                          item18
                                                                                            .sub_repository
                                                                                            .length ===
                                                                                          0
                                                                                        "
                                                                                        icon-pack="feather"
                                                                                        color="iconColor"
                                                                                        >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                                      >
                                                                                      <vs-icon
                                                                                        class="
                                                                                          styledButton
                                                                                        "
                                                                                        v-if="
                                                                                          item18
                                                                                            .sub_repository
                                                                                            .length !=
                                                                                          0
                                                                                        "
                                                                                        @click="
                                                                                          toggleFolder(
                                                                                            item18
                                                                                          )
                                                                                        "
                                                                                        icon-pack="feather"
                                                                                        icon="icon-chevron-right"
                                                                                        color="iconColor"
                                                                                      ></vs-icon>
                                                                                      <vs-icon
                                                                                        icon-pack="feather"
                                                                                        icon="icon-folder"
                                                                                        color="iconColor"
                                                                                      ></vs-icon>
                                                                                      <p
                                                                                        @click="
                                                                                          openFolder(
                                                                                            item18
                                                                                          )
                                                                                        "
                                                                                      >
                                                                                        &nbsp;{{
                                                                                          item18.repository_name
                                                                                        }}
                                                                                      </p>
                                                                                      <vs-tooltip
                                                                                        text="Delete"
                                                                                        position="bottom"
                                                                                        v-if="checkDeletePermission()"
                                                                                      >
                                                                                        &nbsp;<vs-icon
                                                                                          type="flat"
                                                                                          icon-pack="feather"
                                                                                          @click="
                                                                                            folderDelete(
                                                                                              item18.repository_id
                                                                                            )
                                                                                          "
                                                                                          color="danger"
                                                                                          icon="icon-trash-2"
                                                                                        ></vs-icon>
                                                                                        <span></span>
                                                                                      </vs-tooltip>
                                                                                    </vs-col>
                                                                                    <span
                                                                                      :style="{
                                                                                        display:
                                                                                          'none',
                                                                                      }"
                                                                                      :ref="
                                                                                        item18.repository_name
                                                                                      "
                                                                                      v-if="
                                                                                        item18
                                                                                          .sub_repository
                                                                                          .length !=
                                                                                        0
                                                                                      "
                                                                                    >
                                                                                      <vs-row
                                                                                        :key="
                                                                                          index19.id
                                                                                        "
                                                                                        v-for="(
                                                                                          item19,
                                                                                          index19
                                                                                        ) in item18.sub_repository"
                                                                                        vs-type="flex"
                                                                                        vs-justify="flex-start"
                                                                                        vs-align="flex-start"
                                                                                      >
                                                                                        <vs-col
                                                                                          vs-type="flex"
                                                                                          vs-justify="flex-start"
                                                                                          vs-align="center"
                                                                                        >
                                                                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                                            v-if="
                                                                                              item19
                                                                                                .sub_repository
                                                                                                .length ===
                                                                                              0
                                                                                            "
                                                                                            icon-pack="feather"
                                                                                            color="iconColor"
                                                                                            >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                                          >
                                                                                          <vs-icon
                                                                                            class="
                                                                                              styledButton
                                                                                            "
                                                                                            v-if="
                                                                                              item19
                                                                                                .sub_repository
                                                                                                .length !=
                                                                                              0
                                                                                            "
                                                                                            @click="
                                                                                              toggleFolder(
                                                                                                item19
                                                                                              )
                                                                                            "
                                                                                            icon-pack="feather"
                                                                                            icon="icon-chevron-right"
                                                                                            color="iconColor"
                                                                                          ></vs-icon>
                                                                                          <vs-icon
                                                                                            icon-pack="feather"
                                                                                            icon="icon-folder"
                                                                                            color="iconColor"
                                                                                          ></vs-icon>
                                                                                          <p
                                                                                            @click="
                                                                                              openFolder(
                                                                                                item19
                                                                                              )
                                                                                            "
                                                                                          >
                                                                                            &nbsp;{{
                                                                                              item19.repository_name
                                                                                            }}
                                                                                          </p>
                                                                                          <vs-tooltip
                                                                                            text="Delete"
                                                                                            position="bottom"
                                                                                            v-if="checkDeletePermission()"
                                                                                          >
                                                                                            &nbsp;<vs-icon
                                                                                              type="flat"
                                                                                              icon-pack="feather"
                                                                                              @click="
                                                                                                folderDelete(
                                                                                                  item19.repository_id
                                                                                                )
                                                                                              "
                                                                                              color="danger"
                                                                                              icon="icon-trash-2"
                                                                                            ></vs-icon>
                                                                                            <span></span>
                                                                                          </vs-tooltip>
                                                                                        </vs-col>
                                                                                        <span
                                                                                          :style="{
                                                                                            display:
                                                                                              'none',
                                                                                          }"
                                                                                          :ref="
                                                                                            item19.repository_name
                                                                                          "
                                                                                          v-if="
                                                                                            item19
                                                                                              .sub_repository
                                                                                              .length !=
                                                                                            0
                                                                                          "
                                                                                        >
                                                                                          <vs-row
                                                                                            :key="
                                                                                              index20.id
                                                                                            "
                                                                                            v-for="(
                                                                                              item20,
                                                                                              index20
                                                                                            ) in item19.sub_repository"
                                                                                            vs-type="flex"
                                                                                            vs-justify="flex-start"
                                                                                            vs-align="flex-start"
                                                                                          >
                                                                                            <vs-col
                                                                                              vs-type="flex"
                                                                                              vs-justify="flex-start"
                                                                                              vs-align="center"
                                                                                            >
                                                                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-icon
                                                                                                v-if="
                                                                                                  item20
                                                                                                    .sub_repository
                                                                                                    .length ===
                                                                                                  0
                                                                                                "
                                                                                                icon-pack="feather"
                                                                                                color="iconColor"
                                                                                                >&nbsp;&nbsp;&nbsp;&nbsp;</vs-icon
                                                                                              >
                                                                                              <vs-icon
                                                                                                class="
                                                                                                  styledButton
                                                                                                "
                                                                                                v-if="
                                                                                                  item20
                                                                                                    .sub_repository
                                                                                                    .length !=
                                                                                                  0
                                                                                                "
                                                                                                @click="
                                                                                                  toggleFolder(
                                                                                                    item20
                                                                                                  )
                                                                                                "
                                                                                                icon-pack="feather"
                                                                                                icon="icon-chevron-right"
                                                                                                color="iconColor"
                                                                                              ></vs-icon>
                                                                                              <vs-icon
                                                                                                icon-pack="feather"
                                                                                                icon="icon-folder"
                                                                                                color="iconColor"
                                                                                              ></vs-icon>
                                                                                              <p
                                                                                                @click="
                                                                                                  openFolder(
                                                                                                    item20
                                                                                                  )
                                                                                                "
                                                                                              >
                                                                                                &nbsp;{{
                                                                                                  item20.repository_name
                                                                                                }}
                                                                                              </p>
                                                                                              <vs-tooltip
                                                                                                text="Delete"
                                                                                                position="bottom"
                                                                                                v-if="checkDeletePermission()"
                                                                                              >
                                                                                                &nbsp;<vs-icon
                                                                                                  type="flat"
                                                                                                  icon-pack="feather"
                                                                                                  @click="
                                                                                                    folderDelete(
                                                                                                      item20.repository_id
                                                                                                    )
                                                                                                  "
                                                                                                  color="danger"
                                                                                                  icon="icon-trash-2"
                                                                                                ></vs-icon>
                                                                                                <span></span>
                                                                                              </vs-tooltip>
                                                                                            </vs-col>
                                                                                          </vs-row>
                                                                                        </span>
                                                                                      </vs-row>
                                                                                    </span>
                                                                                  </vs-row>
                                                                                </span>
                                                                              </vs-row>
                                                                            </span>
                                                                          </vs-row>
                                                                        </span>
                                                                      </vs-row>
                                                                    </span>
                                                                  </vs-row>
                                                                </span>
                                                              </vs-row>
                                                            </span>
                                                          </vs-row>
                                                        </span>
                                                      </vs-row>
                                                    </span>
                                                  </vs-row>
                                                </span>
                                              </vs-row>
                                            </span>
                                          </vs-row>
                                        </span>
                                      </vs-row>
                                    </span>
                                  </vs-row>
                                </span>
                              </vs-row>
                            </span>
                          </vs-row>
                        </span>
                      </vs-row>
                    </span>
                  </vs-row>
                </div>
              </div>
            </div>

            <vs-row class="mt-4">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                <h5>Types</h5>
              </vs-col>
            </vs-row>
            <vs-divider></vs-divider>

            <div class="footer-sidebar" slot="footer">
              <!-- <vs-row >
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  
                  <h5>Shared Files</h5>
                </vs-col>
                
              </vs-row> -->

              <vs-row>
                <vs-col
                  vs-offset="0.8"
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="8"
                >
                  <h6>
                    <vs-icon icon-pack="feather" icon="icon-file"></vs-icon
                    >&nbsp;Document
                  </h6>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="2.3"
                >
                  <h6>{{ typesOfFiles["document"] }}</h6>
                </vs-col>
              </vs-row>

              <br />
              <vs-row>
                <vs-col
                  vs-offset="0.8"
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="8"
                >
                  <h6>
                    <vs-icon icon-pack="feather" icon="icon-image"></vs-icon
                    >&nbsp;Image
                  </h6>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="2.3"
                >
                  <h6>{{ typesOfFiles["image"] }}</h6>
                </vs-col>
              </vs-row>

              <br />
              <vs-row>
                <vs-col
                  vs-offset="0.8"
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="8"
                >
                  <h6>
                    <vs-icon icon-pack="feather" icon="icon-video"></vs-icon
                    >&nbsp;Video
                  </h6>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="2.3"
                >
                  <h6>{{ typesOfFiles["video"] }}</h6>
                </vs-col>
              </vs-row>

              <br />
              <vs-row>
                <vs-col
                  vs-offset="0.8"
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="8"
                >
                  <h6>
                    <vs-icon icon-pack="feather" icon="icon-music"></vs-icon
                    >&nbsp;Audio
                  </h6>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="2.3"
                >
                  <h6>{{ typesOfFiles["audio"] }}</h6>
                </vs-col>
              </vs-row>

              <br />
            </div>
            <vs-divider></vs-divider>
            <div class="footer-sidebar" slot="footer">
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <h5>Storage Status</h5>
                </vs-col>
              </vs-row>
              <br />

              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <p>{{ totalSize }} used</p>
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-progress
                    :height="10"
                    :percent="totalSizePercent"
                    color="primary"
                    >success</vs-progress
                  >
                </vs-col>
              </vs-row>
            </div>
          </div>
          <div slot="footer"></div>
        </vs-card>
      </vs-col>

      <vs-popup title="Delete Folder" :active.sync="deletepopupflag">
        <vs-row>
          <span>Are you sure to delete this Folder?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button
            @click="folderDeleteConfirm"
            color="primary"
            type="filled"
            class="mr-2 vs-con-loading__container"
            >Confirm</vs-button
          >
          <vs-button @click="deletepopupflag = !deletepopupflag" type="border"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>

      <AllFiles
        v-if="showAllfiles"
        @staticCount="staticCount($event)"
        @refetchedFol="refetchedFol($event)"
        @addedFol="addedFol($event)"
        :testrepo_id="testrepo_id"
        :testrepo_path="testrepo_path"
        :allFile="allFile"
        :buttonHide="hideButton"
      />
      <Folder
        v-if="showFolders"
        :repo_id="this.repo_id"
        :repo_path="this.repo_path"
      />
    </vs-row>
  </div>
</template>

<script>
import AllFiles from '@/views/pages/files/DynamicPage.vue'
import Folder from '@/views/pages/files/Folder.vue'
import createfolder from '@/views/pages/files/CreateFolder.vue'
import createsubfolder from '@/views/pages/files/CreateSubFolder.vue'
import fileupload from '@/views/pages/files/FileUpload.vue'
import vSelect from 'vue-select'
import { folder_list, repoDelete, repoDetails, statics } from '@/api/file.js'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  components: {
    AllFiles,
    Folder,
    vSelect,
    createfolder,
    createsubfolder,
    fileupload
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      active_el: 0,
      filesInfo: [],
      typesOfFiles: [],
      totalSize: '',
      totalSizePercent: 0,
      parentFolder: '',
      firstMount: true,
      hideButton: true,
      iconColor: '#626262',
      allFile: {},
      testrepo_id: '',
      testrepo_path: '',
      showFolders: false,
      showDocuments: false,
      showAudio: false,
      showVideo: false,
      showImage: false,
      showAllfiles: true,
      deletepopupflag: false,
      deleted_id: '',
      data: {
        repository_name: '',
        repository_path: ''
      },
      subfolderData: {
        repository_name: [],
        repository_path: '',
        parent_repository_id: ''
      },
      folders: [],
      repo_id: '',
      repo_path: ''
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Files')
    }
  },
  mounted () {
    folder_list(localStorage.getItem('customer_id'))
      .then((res) => {
        this.folders = res.data.data.repository
        if (this.firstMount === true) {
          this.testrepo_id = this.folders[0].repository_id
          this.testrepo_path = this.folders[0].repository_path
          repoDetails(localStorage.getItem('customer_id'), this.testrepo_id)
            .then((res) => {
              this.allFile = {
                file2: res.data.data.repository.sub_repository,
                file1: res.data.data.repository.files
              }
            })
            .catch((e) => {})
        } else {
          repoDetails(localStorage.getItem('customer_id'), this.testrepo_id)
            .then((res) => {
              this.allFile = {
                file2: res.data.data.repository.sub_repository,
                file1: res.data.data.repository.files
              }
            })
            .catch((e) => {})
        }
      })
      .catch((e) => {})
    // type and storage
    this.staticFileCount()
  },
  methods: {
    activate (el) {
      this.active_el = el
    },
    addedSubFolder (fetchedData) {
      console.log(fetchedData)
      const index = this.folders.findIndex(
        (obj) => obj.repository_id === fetchedData.parent_repository_id
      )
      this.folders[index].sub_repository.unshift(fetchedData)
      this.allFile = {
        file2: this.folders[index].sub_repository,
        file1: this.folders[index].files
      }
      this.firstMount = false
      this.testrepo_id = fetchedData.parent_repository_id
      this.testrepo_path = fetchedData.repository_path
      this.testrepo_path = this.testrepo_path.substring(
        0,
        this.testrepo_path.lastIndexOf('/')
      )
    },
    addedFol (fetchedData) {
      this.firstMount = false
      this.testrepo_id = fetchedData.parent_repository_id
      this.testrepo_path = fetchedData.repository_path
      this.testrepo_path = this.testrepo_path.substring(
        0,
        this.testrepo_path.lastIndexOf('/')
      )
      folder_list(localStorage.getItem('customer_id'))
        .then((res) => {
          this.folders = res.data.data.repository
          repoDetails(localStorage.getItem('customer_id'), this.testrepo_id)
            .then((res) => {
              this.allFile = {
                file2: res.data.data.repository.sub_repository,
                file1: res.data.data.repository.files
              }
            })
            .catch((e) => {})
        })
        .catch((e) => {})
    },

    refetchedFol (fetchedData) {
      // const index = this.folders.findIndex(obj => obj.repository_id === fetchedData[0].parent_repository_id)
      // this.folders[index].sub_repository = this.folders[index].sub_repository.filter(x => fetchedData.filter(y => y.repository_id === x.repository_id).length)
      folder_list(localStorage.getItem('customer_id'))
        .then((res) => {
          this.folders = res.data.data.repository
        })
        .catch((e) => {})
    },

    staticFileCount () {
      statics(localStorage.getItem('customer_id'))
        .then((res) => {
          this.totalSize = res.data.data.size
          this.totalSizePercent = res.data.data.percentage_used
          this.typesOfFiles = res.data.data.types
        })
        .catch((e) => {})
    },
    staticCount () {
      this.staticFileCount()
    },

    addedFile (fetchedData) {
      this.staticFileCount()
      this.testrepo_path = fetchedData.repository_path

      if (fetchedData.parent_repository_id === 0) {
        this.hideButton = true
      } else {
        this.hideButton = false
      }
      this.allFile = {
        file2: fetchedData.sub_repository,
        file1: fetchedData.files
      }
    },

    folderDelete (id) {
      this.deletepopupflag = true
      this.deleted_id = id
    },
    folderDeleteConfirm () {
      repoDelete(localStorage.getItem('customer_id'), this.deleted_id)
        .then((res) => {
          for (let i = 0; i < this.allFile.file2.length; i++) {
            if (this.deleted_id == this.allFile.file2[i].repository_id) {
              this.allFile.file2.splice(i, 1)
            }
          }
          const getData = this.allFile.file2
          this.refetchedFol(getData)
          this.deletepopupflag = false
          this.$vs.notify({
            title: 'Success',
            text: 'Folder deleted successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.staticFileCount()
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    },

    showAudioToggle () {
      this.showAllfiles = false
      this.showFolders = false
      this.showAudio = true
      this.showDocuments = false
      this.showImage = false
      this.showVideo = false
    },
    showVideoToggle () {
      this.showAllfiles = false
      this.showAudio = false
      this.showFolders = false
      this.showDocuments = false
      this.showImage = false
      this.showVideo = true
    },
    showDocumentsToggle () {
      this.showAllfiles = false
      this.showAudio = false
      this.showFolders = false
      this.showDocuments = true
      this.showImage = false
      this.showVideo = false
    },
    showImageToggle () {
      this.showAllfiles = false
      this.showAudio = false
      this.showFolders = false
      this.showDocuments = false
      this.showVideo = false
      this.showImage = true
    },
    showAllFileToggle () {
      this.showAllfiles = true
      this.showFolders = false
      this.showAudio = false
      this.showDocuments = false
      this.showVideo = false
      this.showImage = false
    },
    openFolder (item2) {
      if (item2.parent_repository_id === 0) {
        this.hideButton = true
      } else {
        this.hideButton = false
      }
      // eslint-disable-next-line no-var
      var obj = {
        repository_id: item2.repository_id,
        repository_path: item2.repository_path
      }
      this.$store.commit('UPDATE_REPO', obj)
      this.testrepo_id = this.$store.getters.repoId
      this.testrepo_path = this.$store.getters.repoPath
      repoDetails(localStorage.getItem('customer_id'), this.testrepo_id)
        .then((res) => {
          this.allFile = {
            file2: res.data.data.repository.sub_repository,
            file1: res.data.data.repository.files
          }
          // eslint-disable-next-line eqeqeq
        })
        .catch((e) => {})
    },
    toggleFolder (folder) {
      if (this.$refs[folder.repository_name][0].style.display === 'none') {
        this.$refs[folder.repository_name][0].style.display = 'inline'
      } else {
        this.$refs[folder.repository_name][0].style.display = 'none'
      }
    }
  }
}
</script>
<style>
.files_items_collapse .vs-collapse-item .vs-collapse-item--header {
  font-size: 15px;
}
.files_items_collapse .vs-collapse-item.open-item .vs-collapse-item--header {
  background: #fff;
  color: rgba(var(--vs-primary), 1);
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(var(--vs-primary), 0.1);
}
.files_items_collapse .cstm-collapse-item .header {
  padding: 20px 10px;
  cursor: pointer;
}
.files_items_collapse .cstm-collapse-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.files_items_collapse .cstm-collapse-item .header .material-icons {
  font-size: 14px;
}
.files_items_collapse .cstm-collapse-item .collapse_content {
  display: none;
}
.files_items_collapse .cstm-collapse-item .active {
  background: #fff;
  color: rgba(var(--vs-primary), 1);
  font-weight: 600;
  box-shadow: 0 0 15px rgba(var(--vs-primary), 0.2);
}
.files_items_collapse .cstm-collapse-item .active .header {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.files_items_collapse .cstm-collapse-item .active .header .material-icons {
  transform: rotate(180deg);
}
.files_items_collapse .cstm-collapse-item .active .collapse_content {
  display: block;
  padding: 0 10px 10px;
}
.files_items_collapse .cstm-collapse-item .folders_files_content button {
  padding: 0 !important;
}
.files_items_collapse .cstm-collapse-item .folders_files_content button:hover {
  background: transparent !important;
}
.main_repo .cstm-folder-name {
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
}
</style>
 <style lang="stylus">
 .vs-sidebar-position-right {
   width: 375px !important;
   max-width: 400px !important;
   z-index: 111111111111111 !important;
   /* height: auto !important; */
   /* position: absolute; */
   /* top: 12%; */
 }

 .select_custom {
   height: 40px;
   border: none;
   background-color: white;
   border: 1px solid #cccccc;
   color: #787878;
   font-size: 14px;
   width: 100%;
   border-radius: 5px;
 }

 .header-sidebar-style {
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   width: 100%;

   h4 {
     display: flex;
     align-items: center;
     justify-content: center;
     width: 100%;

     > button {
       margin-left: 10px;
     }
   }
 }

 .footer-sidebar-style {
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 100%;

   > button {
     border: 0px solid rgba(0, 0, 0, 0) !important;
     border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
     border-right: 1px solid rgba(0, 0, 0, 0.07) !important;
   }
 }

 .inputField {
   height: 44px;
   border: none;
   background-color: white;
   color: #787878;
   font-size: 12px;
   width: 100%;
   border-bottom: 2px dotted #cccccc;
 }

 .styledButton:hover {
   color: #41CFDD;
 }

 .cstm-collapse-item .con-content--item {
   max-height: 200px;
   overflow-x: hidden;
   overflow-y: auto;
 }

 .cstm-folder-name {
   word-break: break-word;
 }
</style>